const BasketPage = () => {
    return ( 
        <h1>hi</h1>
     );
}
 
export default BasketPage;